import { Controller } from "@hotwired/stimulus"
import { showConfirmModal } from "../lib/custom_confirm"

// Copies several default values (configured in app settings) into their form
// fields with a SINGLE button — e.g. the Bio & Tagline card copies Tagline,
// Tagline - Sub, and Bio at once. Each entry in `fieldsValue` is
// { target: "<dom id>", default: "<value>" }. If ANY targeted field is
// non-empty we confirm once before clobbering, via the app's styled modal.
//
// Targets are resolved by id (document.getElementById) so this works for both
// plain inputs and TipTap's hidden input — dispatching `input`+`change` lets the
// editor re-sync from its hidden input.
export default class extends Controller {
  static values = {
    fields: Array,
    confirmMessage: { type: String, default: "Replace the current values with the defaults?" }
  }

  async copy(event) {
    event?.preventDefault()
    const fields = this.fieldsValue
      .map((field) => ({ input: document.getElementById(field.target), value: field.default }))
      .filter((field) => field.input)
    if (fields.length === 0) return

    const anyFilled = fields.some((field) => field.input.value.trim() !== "")
    if (anyFilled) {
      const confirmed = await showConfirmModal(this.confirmMessageValue, {
        variant: "warning",
        title: "Replace values",
        confirmText: "Replace"
      })
      if (!confirmed) return
    }

    fields.forEach((field) => {
      field.input.value = field.value
      field.input.dispatchEvent(new Event("input", { bubbles: true }))
      field.input.dispatchEvent(new Event("change", { bubbles: true }))
    })
  }
}
